export enum ItemStatus {
  NOT_RETURNED = 'NOT_RETURNED',
  RETURNED = 'RETURNED',
  PAID = 'PAID',
  PENDING_RETURN = 'PENDING_RETURN',
  DEPOSIT = 'DEPOSIT',
}
